<template>
  <v-main id="mainCheckout" class="mainCheckout">
    <!-- Selecionar agências Dialog  -->
    <v-dialog v-model="agenciasDialog" max-width="700px">
      <v-toolbar
        v-if="this.agencias && this.agencias.length > 0"
        color="#FFFFFF"
      >
        <v-toolbar-title class="text-center"
          >Selecione a agência para postagem</v-toolbar-title
        >
      </v-toolbar>

      <v-toolbar v-else color="#bc0000" elevation="0">
        <v-toolbar-title class="text-center" style="color: #ffffff"
          >Atenção</v-toolbar-title
        >
      </v-toolbar>

      <div v-if="this.agencias && this.agencias.length > 0">
        <v-list v-for="agencia in agencias" :key="agencia.id">
          <v-list-item>
            <div style="border-bottom: 1px solid #cccccc" class="d-flex">
              <div>
                <p>
                  <b>Empresa: </b>{{ agencia.company_name }}, <b>Estado: </b
                  >{{ agencia.address.city.state.state }}, <b>Cidade: </b
                  >{{ agencia.address.city.city }}, <b>Endereço: </b
                  >{{ agencia.address.address }}, <b>E-mail: </b
                  >{{ agencia.email }}, <b>Telefone: </b
                  >{{ agencia.phone.phone }}
                </p>
              </div>
              <div>
                <v-btn
                  outlined
                  class="primary-button ma-2"
                  @click="selecionarAgencia(agencia.id)"
                >
                  <span class="py-2"
                    >Selecionar <br />
                    agência</span
                  >
                </v-btn>
              </div>
            </div>
          </v-list-item>
        </v-list>
      </div>

      <v-list v-else>
        <h3 class="px-3">
          A JadLog não tem nenhuma agência nessa localidade para postagem.
        </h3>
        <h3 class="px-3 mb-2 label-details">
          Acesse o melhor envio para fazer o envio manualmente,
          <a target="_blank" :href="`${urlMelhorEnvio}painel`"
            >Acessar melhor envio</a
          >
        </h3>
        <br />
      </v-list>
    </v-dialog>

    <!-- Separação Dialog  -->
    <v-dialog v-model="separarDialog" max-width="500px">
      <ConfirmModal
        textMessage="Você confirma que o pedido vai ser separado?"
        textObservation1="Certifique-se que o status selecionado está correto pois ao mudar não é possível voltar atrás"
        cancelBtn="Cancelar"
        okbtn="Confirmar"
        :order="pedido"
        @close="separarDialog = false"
        @action="
          ((separarDialog = false), (pedido.orderStatus = 6)), editStatus()
        "
        @closeNoLoading="closeNoLoading"
        :key="dialogKey"
      />
    </v-dialog>

    <!-- Entregue Dialog  -->
    <v-dialog v-model="entregarDialog" max-width="500px">
      <ConfirmModal
        textMessage="Você confirma a entrega e o recebimento desse pedido?"
        textObservation1="Certifique-se que o status selecionado está correto pois ao mudar não é possível voltar atrás"
        cancelBtn="Cancelar"
        okbtn="Confirmar"
        :order="pedido"
        @close="entregarDialog = false"
        @action="
          ((entregarDialog = false), (pedido.orderStatus = 8)), editStatus()
        "
        @closeNoLoading="closeNoLoading"
        :key="dialogKey"
      />
    </v-dialog>

    <!--Gerar Etiqueta-->
    <v-dialog v-model="gerarEtiquetaDialog" max-width="700px">
      <GenerateTagModal
        :order="pedido"
        @close="gerarEtiquetaDialog = false"
        @action="generateShippingLabel"
        @closeNoLoading="closeNoLoading"
        :key="dialogKey"
      />
    </v-dialog>

    <!--Enviar Dialog-->
    <v-dialog v-model="enviarDialog" max-width="450px">
      <EnviadoStatusModal
        :order="pedido"
        @close="enviarDialog = false"
        @action="recebenDados"
        @closeNoLoading="closeNoLoading"
        :key="dialogKey"
      />
    </v-dialog>

    <!--Cancelar Dialog-->
    <v-dialog v-model="cancelareDialog" max-width="900px">
      <CancelarStatusModal
        ref="cancelarStatusModal"
        :order="pedido"
        @close="cancelareDialog = false"
        @action="dadosCancelamento"
        @closeNoLoading="closeNoLoading"
        :key="dialogKey"
      />
    </v-dialog>

    <!--Devolver Dialog-->
    <v-dialog v-model="devolverDialog" max-width="450px">
      <ChangeStatusModal
        :title="'devolver'"
        :order="pedido"
        @close="devolverDialog = false"
        @action="
          ((devolverDialog = false), (pedido.orderStatus = 5)), editStatus()
        "
        @closeNoLoading="closeNoLoading"
        :key="dialogKey"
      />
    </v-dialog>

    <!--Retirar Dialog-->
    <v-dialog v-model="retirarDialog" max-width="500px">
      <ConfirmModal
        textMessage="Você confirma que o pedido pode ser retirado"
        textObservation1="Certifique-se que o status selecionado está correto pois ao mudar não é possível voltar atrás"
        cancelBtn="Cancelar"
        okbtn="Confirmar"
        :order="pedido"
        @close="retirarDialog = false"
        @action="
          ((retirarDialog = false), (pedido.orderStatus = 9)), editStatus()
        "
        @closeNoLoading="closeNoLoading"
        :key="dialogKey"
      />
    </v-dialog>

    <!-- inserir codigo de postagem Dialog-->
    <v-dialog v-model="inserirCodigoPostagemDialog" max-width="500px">
      <v-card class="card pa-6 mx-auto" elevation="1">
        <div
          class="px-2 d-flex"
          style="justify-content: center; text-align: center"
        >
          <h2 class="justify-center">
            <span>Insira o Codigo de postagem</span>
          </h2>
        </div>
        <v-form ref="firstForm">
          <v-col cols="12" sm="12" md="12" lg="12">
            <v-text-field
              dense
              outlined
              placeholder="Digite o código de postagem"
              v-model="trackingCode"
              required
            />
          </v-col>
        </v-form>
        <div>
          <v-row class="d-flex ma-0 pa-0" cols="12">
            <v-col cols="12" class="d-flex justify-center">
              <v-btn
                width="50%"
                outlined
                class="cancelBtn mr-2"
                @click="inserirCodigoPostagemDialog = false"
              >
                <span class="cancel">Cancelar</span>
              </v-btn>

              <v-btn width="50%" class="okBtn mr-2" @click="addTrackingCode()">
                <span class="yep">Confirmar</span>
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-dialog>

    <!-- atualiza/cadastra link de rastreio Dialog-->
    <v-dialog v-model="alterarLinkRastreioDialog" max-width="700px">
      <v-card class="pa-6" elevation="1">
        <div
            class="px-2 d-flex"
            style="justify-content: center; text-align: center"
        >
          <h2 class="justify-center">
            <span v-if="pedido && pedido.trackingLink">Editar link de rastreio</span>
            <span v-else >Cadastrar link de rastreio</span>
          </h2>
        </div>

        <v-form class="pa-0 ma-0 mt-3" ref="firstForm">
          <v-text-field
              dense
              outlined
              full-width
              style="width: 100%!important;"
              placeholder="Digite o código de postagem"
              v-model="trackingLink"
              required
          ></v-text-field>
        </v-form>

        <v-col cols="12" class="d-flex justify-space-between ma-0 pa-0  ">
          <v-btn
              width="48%"
              outlined
              class="cancelBtn mr-3"
              @click="alterarLinkRastreioDialog = false"
          >
            <span class="cancel">Cancelar</span>
          </v-btn>

          <v-btn :disabled="!trackingLink" width="50%" color="primary" class="okBtn mr-2" @click="updateTrackingLink()">
            <span class="yep">Confirmar</span>
          </v-btn>
        </v-col>
      </v-card>
    </v-dialog>

    <!-- imprimir etiquetar Dialog-->
    <v-dialog v-model="imprimirEtiquetaDialog" max-width="700px">
      <v-card class="pa-4" elevation="1">
        <div
            class="px-2 d-flex"
            style="justify-content: center; text-align: center"
        >
          <h2 class="justify-center">
            <span >Opções para imprimir etiqueta</span>
          </h2>
        </div>

        <v-row cols="12" class="mt-3">
          <v-col cols="12">
            <a class="link-etiquette" v-if="pedido && pedido.linkToPrintLabel" :href="pedido.linkToPrintLabel" target="_blank">
              <p>Clique aqui para baixar direto no site do melhor envio</p>
            </a>

            <div v-if="etiquettesFormatJpeg && etiquettesFormatJpeg.length > 0">
              <v-divider></v-divider>
              <ol style="margin-left: -10px">
                <li
                    v-for="(etiquette, index) in etiquettesFormatJpeg"
                    :key="`${etiquette.jpeg}_${index}`"
                >
                  <a
                      :href="etiquette.jpeg"
                      target="_blank"
                      class="link-etiquette"
                  >
                    <span>Clique aqui para baixar imagem da etiqueta {{etiquette.label}}</span>
                  </a>
                </li>
              </ol>
            </div>

            <div class="mt-4" v-if="etiquettesFormatPdf && etiquettesFormatPdf.length > 0">
              <v-divider></v-divider>
              <ol style="margin-left: -10px">
                <li
                    v-for="(etiquette, index) in etiquettesFormatPdf"
                    :key="`${index}`"
                >
                  <a
                      @click="downloadEtiquettePdf(etiquette)"
                      class="link-etiquette"
                  >
                    <span>Clique aqui para baixar o pdf da etiqueta {{etiquette.label}}</span>
                  </a>
                </li>
              </ol>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>

    <v-row
      class="px-6 pb-3 pt-0"
      style="align-self: center !important; font-weight: bolder; color: #e30011"
    >
      <v-icon class="pr-2" @click="$router.go(-1)" color="#E30011"
        >mdi-arrow-left</v-icon
      >

      <div @click="$router.go(-1)" style="align-self: center; cursor: pointer">
        voltar para gestão de pedidos
      </div>
    </v-row>

    <v-card class="d-flex align-center ma-0 pa-0" elevation="0">
      <div class="px-4 py-0" style="width: 100% !important">
        <div class="d-flex">
          <v-card-title class="card-title ma-0 pa-7">
            Pedido {{ this.pedido.orderCode }}
          </v-card-title>

          <v-spacer></v-spacer>

          <v-btn outlined fab tile small class="mt-4" @click="excel">
            <v-icon>mdi-download</v-icon>
          </v-btn>
        </div>

        <v-card-text class="card-text d-flex py-0">
          <v-row class="px-4 pb-5"
            v-if="(pedido.orderStatus === pedidoAprovado || disabled(pedidoAprovado) &&
            (!(pedido.orderStatus === pedidoCancelado) && !disabled(pedidoCancelado) && !(pedido.orderStatus === pedidoDevolvido) && !disabled(pedidoDevolvido)))"
          >
            <v-btn
              class="transp-button ghost-buttons-outlined-black mr-2"
              :disabled="disabled(pedidoSeparando)"
              elevation="1"
              outlined
              @click="separarDialog = true"
            >
              Pedido em separação
            </v-btn>

            <v-btn
              class="transp-button ghost-buttons-outlined-black mr-2"
              :disabled="!(this.pedido.orderStatusList.find((x) => x.status === pedidoSeparando)) || disabled(pedidoEtiqueta) || disabled(pedidoEnviado)"
              elevation="1"
              outlined
              @click="gerarEtiqueta()"
            >
              Gerar Etiqueta
            </v-btn>

            <v-btn
              class="transp-button ghost-buttons-outlined-black mr-2"
              :disabled="!(this.pedido.orderStatusList.find((x) => x.status === pedidoSeparando)) || disabled(pedidoEnviado)"
              elevation="1"
              outlined
              @click="enviarDialog = true"
            >
              Pedido enviado
            </v-btn>

            <v-btn
              class="transp-button ghost-buttons-outlined-black mr-2"
              :disabled="!(this.pedido.orderStatusList.find((x) => x.status === pedidoEnviado)) || disabled(pedidoEntregue)"
              elevation="1"
              outlined
              @click="entregarDialog = true"
            >
              Pedido entregue
            </v-btn>
          </v-row>

          <v-row v-else class="">
            <div class="swiper-container">
              <p class="swiper-control"></p>
              <div class="swiper-wrapper timeline">
                <div class="swiper-slide" v-for="(item, idx) in steps" :key="idx">
                  <div class="status">
                    <span class="status-title">{{ item.title }}</span>
                    <span class="date">{{ item.dateLabel }}</span>
                  </div>
                </div>
              </div>
            </div>
          </v-row>
        </v-card-text>
      </div>
    </v-card>

    <v-row class=" pa-5 py-1 pa mx-3" v-if="itemsCancelled && itemsCancelled.length > 0">
      <v-expansion-panels
          style="background: rgba(255, 165, 0, 0.5)"
          class="mb-4 elevation-0"
      >
        <v-expansion-panel>
          <v-expansion-panel-header style="height: 70px" color="rgba(255, 165, 0, 0.5)">
            <section class="d-flex align-center">
              <v-icon size="40" color="#bc0000">
                mdi-alert-circle-outline
              </v-icon>

              <h2 style="color: #bc0000">Atenção: Alguns itens desse pedido foram cancelados, clique aqui para ver os itens.</h2>
            </section>
            <template v-slot:actions>
              <v-icon size="40">
                mdi-chevron-down
              </v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row cols="12" class="pa-0 ma-0">
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="pa-0 ma-0 mt-2 ">
                <div class="span-title pa-0 ma-0 px-5 py-2">Itens cancelados</div>
                <v-data-table
                    ref="table"
                    :loading="loading"
                    loading-text="Carregando..."
                    no-data-text="Nenhum pedido encontrado"
                    :headers="headersCancelled"
                    :items="itemsCancelled"
                    class="elevation-0"
                    hide-default-footer
                    :items-per-page="pageSize"
                    :header-props="headerProps"
                    :key="componentKey"
                >
                  <template v-slot:[`item.productSku`]="{ item }">
                    {{ item.productSku.attributes[0].name }}
                  </template>


                  <template v-slot:[`item.price`]="{ item }">
                    {{
                      item.price.toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })
                    }}
                  </template>

                  <template v-slot:[`item.priceOriginal`]="{ item }">
                    {{
                      item.productSku.differentValue.toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })
                    }}
                  </template>

                  <template v-slot:[`item.subTotal`]="{ item }">
                    {{
                      (item.qty * item.productSku.differentValue).toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })
                    }}
                  </template>

                  <template v-slot:[`item.actions`]="{ item }">
                    {{
                      (item.qty * item.price).toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })
                    }}
                  </template>
                  <template v-slot:[`item.refundDate`]="{ item }">
                    {{
                      formatDate(item.refundDate)
                    }}
                  </template>
                </v-data-table>

                <v-divider class="mt-5"></v-divider>
                <p class="ml-3 mt-2"><strong>Motivo: </strong>{{pedido.descriptionOfCancellation && pedido.descriptionOfCancellation.length > 0? pedido.descriptionOfCancellation : '-'}}</p>
              </v-col>
            </v-row>

          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
    <v-row
      class="ma-0 pa-5 py-2"
      cols="12"
      xs="12"
      sm="12"
      md="12"
      lg="12"
      xl="12"
    >
      <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
        <v-card class="cards ma-0 pa-0" height="300">
          <div class="span-title pa-0 ma-0 px-5 py-2">
            Informações do Cliente
          </div>
          <div class="px-1 pt-1 py-2">
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td class="informacoes-cliente">Nome do cliente</td>
                    <td class="informacoes-cliente-dados">
                      {{ currentClient.name }}
                    </td>
                  </tr>

                  <tr>
                    <td class="informacoes-cliente">E-mail</td>
                    <td class="informacoes-cliente-dados">
                      {{ currentClient.email }}
                    </td>
                  </tr>

                  <tr>
                    <td class="informacoes-cliente">Telefone</td>
                    <td class="informacoes-cliente-dados">
                      <v-btn
                          v-if="currentClient && currentClient.phoneNumber && currentClient.phoneNumber.length > 0"
                          class="mx-2 icon_whatsapp mb-1"
                          :href="`https://api.whatsapp.com/send?1=pt_BR&phone=55${currentClient.phoneNumber.replace(/\D/g, '')}`"
                          target="_blank"
                          icon
                      >
                        <v-icon color="#25d366" size="28px">mdi-whatsapp</v-icon>
                      </v-btn>
                      {{
                        currentClient.phoneNumber
                          ? currentClient.phoneNumber
                          : "Sem registro"
                      }}
                    </td>
                  </tr>

                  <tr>
                    <td class="informacoes-cliente">CPF/CNPF</td>
                    <td class="informacoes-cliente-dados">
                      {{
                        currentClient.cnpj ? currentClient.cnpj : "Sem registro"
                      }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
        <v-card class="cards ma-0 pa-0" height="300">
          <div class="span-title pa-0 ma-0 px-5 py-2">Endereço de entrega</div>

          <v-col
            cols="12"
            md="12"
            class="ma-0 pa-0 py-4 px-4"
            style="text-align: start"
          >
            <div>
              <strong>{{ pedido.addressName }}</strong>
            </div>

            <div>CEP: {{ pedido.address }}</div>
          </v-col>
        </v-card>
      </v-col>

      <v-col ccols="12" xs="12" sm="12" md="12" lg="6" xl="6">
        <v-card class="cards ma-0 pa-0" height="270">
          <div class="span-title pa-0 ma-0 px-5 py-2">
            Informações da postagem
          </div>
          <div class="px-1 pt-1 py-2">
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                <tr>
                  <td class="informacoes-cliente">Imprimir etiqueta</td>
                  <td class="informacoes-cliente-dados">
                    <span v-if="!pedido.linkToPrintLabel">Sem Registro</span>

                    <v-tooltip bottom v-if="pedido && pedido.etiquetaId">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            @click="getEtiquette()"
                            v-bind="attrs"
                            v-on="on"
                            icon
                        >
                          <v-icon size="23" color="#BC0000">mdi-printer</v-icon>
                        </v-btn>
                      </template>
                      <span >Imprimir etiqueta</span>
                    </v-tooltip>
                  </td>
                </tr>

                <tr>
                  <td class="informacoes-cliente">Codigo de postagem</td>
                  <td class="informacoes-cliente-dados">
                      <span v-if="pedido.trackingCode">
                        {{ pedido.trackingCode }}
                      </span>
                    <v-btn
                        v-else-if="
                          !pedido.trackingCode && pedido.linkToPrintLabel
                        "
                        class="ghost-buttons-outlined-black"
                        elevation="0"
                        width="130"
                        @click="inserirCodigoPostagemDialog = true"
                    >
                      Adicionar código
                    </v-btn>
                    <span v-else>Sem Registro</span>
                  </td>
                </tr>

                <tr>
                  <td class="informacoes-cliente">Transportadora</td>
                  <td class="informacoes-cliente-dados">
                      <span v-if="pedido.companyName">{{
                          pedido.companyName
                        }}</span>
                    <span v-if="!pedido.companyName">Sem Registro</span>
                  </td>
                </tr>

                <tr>
                  <td class="informacoes-cliente">Link para acompanhar</td>
                  <td class="informacoes-cliente-dados d-flex align-center justify-end" >
                    <a
                        v-if="pedido.trackingLink"
                        :href="pedido.trackingLink"
                        target="_blank"
                    >
                      Rastrear
                    </a>
                    <span v-if="!pedido.trackingLink">Sem Registro</span>

                    <v-tooltip bottom v-if="pedido && pedido.etiquetaId">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            @click="showModalTrackingLink()"
                            v-bind="attrs"
                            v-on="on"
                            icon
                        >
                          <v-icon size="23" color="#BC0000">mdi-pencil-box-outline</v-icon>
                        </v-btn>
                      </template>
                      <span v-if="pedido && pedido.trackingLink">Editar link de rastreio</span>
                      <span v-else>Cadastrar link de rastreio</span>
                    </v-tooltip>
                  </td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
          <br />
        </v-card>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
        <v-card class="cards ma-0 pa-0 pc-0" height="270">
          <div class="span-title pa-0 ma-0 px-5 py-2">Pagamento</div>
          <div v-if="pedido.paymentMethod === bankSlip" class="ma-0 pa-0 py-5">
            <div style="display: inline-flex; text-align: end">
              <v-img
                  class="mx-2"
                  src="../../../assets/boleto.svg"
                  width="70"
                  height="50"
                  alt="boleto"
                  title="boleto"
              >
              </v-img>
              <h3>
                {{
                  (pedido.fretePrice + pedido.totalPrice).toLocaleString(
                      "pt-br",
                      { style: "currency", currency: "BRL" }
                  )
                }}
              </h3>
            </div>
            <div class="mx-3" v-if="pedido.orderStatus !== pedidoCancelado">
              <a class="text-left" :href="pedido.urlBoleto" target="_blank">
                Acessar boleto
              </a>
            </div>
          </div>

          <div v-else-if="pedido.paymentMethod === pix" class="ma-0 pa-0 py-5">
            <div style="display: inline-flex; text-align: end">
              <v-img
                  class="mx-2"
                  src="../../../assets/pix-icon.svg"
                  width="30"
                  height="30"
                  alt="boleto"
                  title="boleto"
              >
              </v-img>
              <h3>
                {{
                  (pedido.fretePrice + pedido.totalPrice).toLocaleString(
                      "pt-br",
                      { style: "currency", currency: "BRL" }
                  )
                }}
              </h3>
            </div>
            <div class="mx-3" v-if="showQrCodePix()">
              <a class="text-left" :href="pedido.qrCodeUrlPix" target="_blank">
                Acessar Qr code
              </a>
            </div>
            <div
                v-if="showQrCodePix()"
                class="content_copy_qrcode mx-3"
                @click="copyQrcode('qrCodePix')"
            >
              <p style="text-align: left" class="">Copiar Qr Code</p>
              <p id="qrCodePix">{{ pedido.qrCodePix }}</p>
              <img
                  width="22"
                  height="22"
                  class="copy_qrcode"
                  src="../../../assets/copSolid.svg"
              />
            </div>
          </div>

          <div
              v-else
              style="
              display: flex;
              flex-wrap: wrap;
              text-align: start;
              padding-top: 10px;
            "
          >
            <div style="padding-right: 10px" class="px-5">
              <v-img
                  v-bind:src="
                  require('../../../assets/' + pedido.brandCard + '.svg')
                "
                  width="50"
                  height="39"
                  :alt="pedido.brandCard"
                  :title="pedido.brandCard"
              ></v-img>
              <p style="text-align: center; font-size: 12px; font-weight: bold">
                {{ pedido.brandCard }}
              </p>
            </div>

            <div class="dados-pagamento">
              {{ pedido.numberCardFlags }}
              <div>
                {{
                  (pedido.totalPrice + pedido.fretePrice + pedido.installmentsInterest).toLocaleString(
                    "pt-br",
                    { style: "currency", currency: "BRL" }
                  )
                }}
                em
                {{
                  pedido.creditInstallments ? pedido.creditInstallments : "1"
                }}x
              </div>
            </div>
          </div>
          <div class="mx-3">
            <div class="d-flex justify-space-between">
              <span>
                Status: <b>{{ statusPagamento() }}</b>
              </span>

              <span>
                Cupom:
                <b>{{ pedido.coupon ? pedido.coupon.code : currentClient.type === userTypeInstaller ? "DESCONTO-APLICADOR" : "Nenhum" }}</b>
              </span>
            </div>


            <div class="d-flex justify-space-between">
              <span>
                Forma de envio:
                <b>
                  {{
                    pedido.deliveryMethod != null
                        ? deliveryMethods[pedido.deliveryMethod]
                        : "Sem registro"
                  }}</b>
              </span>

              <span>
                Prazo entrega:
                <b>{{
                    pedido.prazoEntrega
                        ? `${pedido.prazoEntrega} dias`
                        : "Sem registro"
                  }}</b>
              </span>
            </div>

            <div class="d-flex justify-space-between">
              <span>
                Enviar por:
                <b
                    v-if="(freightQuotation && freightQuotation.company && freightQuotation.company.name) || (freightQuotation && freightQuotation.name)"
                >
                  {{ freightQuotation && freightQuotation.name ? freightQuotation && freightQuotation.name : ''}}
                  {{ freightQuotation && freightQuotation.company && freightQuotation.company.name ? freightQuotation.company.name : ''}}
                </b>
                <b v-else>-</b>
              </span>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-row
        class="ma-0 pa-5 py-2"
        cols="12"
        xs="12"
        sm="12"
        md="12"
        lg="12"
        xl="12"
    >
      <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
        <v-card class="cards ma-0 pa-0" height="100%">
          <div class="span-title pa-0 ma-0 px-5 py-2">Total pago</div>
          <div class="px-1 pt-1 py-2">
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                <tr>
                  <td class="total-pago">
                    <strong>Subtotal (bruto)</strong>
                  </td>
                  <td class="total-pago text-right">
                    <span>{{
                        calculateSubtotal().toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })
                      }}</span>
                  </td>
                </tr>

                <tr>
                  <td class="total-pago">
                    <strong>Desconto</strong>
                      <strong v-if="pedido.coupon">
                        ({{pedido.coupon.code}})
                      </strong>
                      <strong v-if="!pedido.coupon && pedido.discount && Number(pedido.discount) > 0">
                        (Promoção)
                      </strong>
                  </td>
                  <td class="total-pago text-right">
                    <span>
                      {{
                        pedido.discount.toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })
                      }}
                    </span>
                  </td>
                </tr>

                <tr>
                  <td class="total-pago">
                    <strong>Frete</strong>
                  </td>
                  <td class="total-pago text-right">
                    <span>
                      {{
                        pedido.fretePrice.toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })
                      }}
                    </span>
                  </td>
                </tr>

                <tr>
                  <td class="total-pago">
                    <strong>Comissão da plataforma</strong>
                  </td>
                  <td class="total-pago text-right">
                    <span v-if="pedido && pedido.shipment && pedido.shipment.commission">{{
                        pedido.shipment.commission.toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })
                      }}</span>
                    <span v-else>{{
                        (0).toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })
                      }}</span>
                  </td>
                </tr>

                <tr>
                  <td class="total-pago">
                    <strong>Taxa de transação</strong>
                  </td>
                  <td class="total-pago text-right">
                    <span >{{
                        (pedido.installmentsInterest + pedido.fees + pedido.processingCost).toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })
                      }}</span>
                  </td>
                </tr>

                <tr>
                  <td class="total-pago">
                    <strong>Total líquido</strong>
                  </td>
                  <td class="total-pago text-right">
                    <span >{{
                        (
                            (pedido.totalPrice + pedido.fretePrice + pedido.installmentsInterest) - ((pedido && pedido.shipment &&  pedido.shipment.commission ? pedido.shipment.commission : 0) + pedido.fees + pedido.processingCost)
                        ).toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })
                      }}</span>
                  </td>
                </tr>

                <tr>
                  <td colspan="2" class="total-pago text-left pt-2">
                     <h4><strong>Legenda</strong></h4>
                    <div>
                      <strong>Taxa de processamento por boleto: {{
                          (3.49).toLocaleString("pt-br", {
                            style: "currency",
                            currency: "BRL",
                          })
                        }} </strong>
                    </div>
                    <div>
                      <strong>Taxa de processamento por pix: 1.19% </strong>
                    </div>
                    <div>
                      <strong>Taxa de processamento por cartão de crédito: {{
                          (0.99).toLocaleString("pt-br", {
                            style: "currency",
                            currency: "BRL",
                          })
                        }} </strong>
                    </div>
                    <div>
                      <strong>Parcelamento em 1x: 3.48% </strong><br/>
                      <strong>Parcelamento em 2x a 5x: 3.66% </strong><br/>
                    </div>
                  </td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row
        class="ma-0 pa-5 py-2"
        cols="12"
        xs="12"
        sm="12"
        md="12"
        lg="12"
        xl="12"
    >
      <v-col cols="12" md="12" sm="12">
        <v-card class="cards ma-0 pa-0">
          <div class="span-title pa-0 ma-0 py-2 px-5">Itens comprados</div>

          <v-data-table
              ref="table"
              :loading="loading"
              loading-text="Carregando..."
              no-data-text="Nenhum pedido encontrado"
              :headers="headers"
              :items="order"
              class="elevation-1"
              hide-default-footer
              :items-per-page="pageSize"
              :header-props="headerProps"
              :key="componentKey"
          >
            <template v-slot:[`item.productSku`]="{ item }">
              {{ item.productSku.attributes[0].name }}
            </template>

            <template v-slot:[`item.price`]="{ item }">
              {{
                item.price.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              }}
            </template>
            <template v-slot:[`item.priceOriginal`]="{ item }">
              {{
                item.productSku.differentValue.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              }}
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              {{
                (item.qty * item.price).toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              }}
            </template>
            <template v-slot:[`item.subTotal`]="{ item }">
              {{
                (item.qty * item.price).toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              }}
            </template>
          </v-data-table>
        </v-card>
      </v-col>

    </v-row>

    <v-row
      class="ma-0 pa-5 py-2"
      cols="12"
      xs="12"
      sm="12"
      md="12"
      lg="12"
      xl="12"
    >
      <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
        <v-card class="cards ma-0 pa-0">
          <div class="span-title pa-0 ma-0 py-2 px-5">Avaliação do cliente</div>
          <div v-if="pedido && pedido.review" class="pl-5 pb-3">
            <div class="mt-3">
              <label class="mt-2"><strong>Nota para o pedido</strong></label>
              <v-rating
                  v-model="pedido.review.note"
                  bg-color="orange-lighten-1"
                  color="normalred"
                  class="mt-2"
                  readonly
              ></v-rating>
            </div>
            <div class="mt-3">
              <strong>Comentário</strong>

              <p class="mt-3">
                {{pedido.review.evaluation ? pedido.review.evaluation : 'Sem comentário.'}}
              </p>
            </div>
          </div>
          <div class="" v-else>
            <p class="postageAddress ml-5">O cliente ainda não avaliou o pedido!</p>
            <br/>
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
        <v-card class="cards ma-0 pa-0">
          <div class="span-title pa-0 ma-0 py-2 px-5">Descrição do status da transação</div>
          <p class="postageAddress ml-5">{{pedido.transactionMessage && pedido.transactionMessage.length > 0? pedido.transactionMessage : '-'}}</p>
          <br/>
        </v-card>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
        <v-card class="cards ma-0 pa-0" height="270">
          <div class="span-title pa-0 ma-0 px-5 py-2">
            Endereço para postagem
          </div>
          <p v-if="pedido.postageAddress" class="postageAddress">{{ pedido.postageAddress }}</p>
          <p v-else class="postageAddress ml-5">Ainda não gerou a etiqueta</p>
          <br />
        </v-card>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
        <v-card
          class="cards ma-0 pa-0 observacao-altura"
          style="align-self: center"
        >
          <div class="span-title pa-0 ma-0 px-5 py-2">Observações</div>
          <v-textarea
            v-model="pedido.resaleObs"
            name="input-7-1"
            class="pa-2"
            filled
            outlined
            height="150"
            auto-grow
            label="Insira suas observações"
          ></v-textarea>

          <v-row
            class="px-2"
            cols="12"
            md="12"
            sm="12"
            style="padding-left: 10px; margin-top: -20px"
          >
            <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
              <v-btn
                class="ghost-buttons-outlined-black"
                @click="$router.go(-1)"
                elevation="0"
                width="100%"
              >
                Cancelar</v-btn
              >
            </v-col>

            <v-col
              cols="12"
              xs="12"
              sm="12"
              md="6"
              lg="6"
              xl="6"
              @click="editResaleemarks()"
            >
              <v-btn class="sixth-button" elevation="0" width="100%">
                Salvar</v-btn
              >
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-row
        class="ma-0 pa-5 py-2"
        cols="12"
        xs="12"
        sm="12"
        md="12"
        lg="12"
        xl="12"
    >

    </v-row>
  </v-main>
</template>

<style scoped>
.icon_whatsapp:hover {
  transform: scale(1.2);
}
.content_copy_qrcode {
  margin-top: 10px;
  height: 20px !important;
  cursor: pointer;
  display: flex;
  align-items: start;
}

#qrCodePix {
  display: none;
}
.copy_qrcode {
  margin-left: 5px !important;
  margin-top: -3px;
}
.postageAddress {
  margin: 10px;
  font-style: normal;
  font-weight: 300;
  font-size: 13.5px;
  color: #000000;
}
.dados-pagamento {
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  color: #000000;
  padding-left: 10px;
}

.informacoes-cliente-dados {
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  color: #000000;
  text-align: right;
}

.informacoes-cliente {
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  color: #000000;
}

.red-button {
  background-color: transparent !important;
  color: #bc0000 !important;
  width: 105px !important;
  height: 47px !important;

  border: 2px solid #bc0000 !important;
  box-sizing: border-box !important;
  border-radius: 8px !important;
}

.image-container {
  width: 170px;
  height: 130px !important;

  background: #dadada !important;
  border-radius: 20px !important;
}

.transp-button {
  width: 170px;
  font-family: Roboto !important;
  font-style: normal !important;
  font-weight: 300 !important;
  font-size: 14px !important;
  height: 46px !important;
  line-height: 69.69% !important;
  letter-spacing: 0.15px !important;
  margin-bottom: 10px;
}

.text {
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 22px;
  line-height: 0px;

  letter-spacing: 0.15px;

  color: #2d3038;
}

.cards {
  height: auto;
}

.cards-small {
  height: 300px !important;
  border-radius: 8px;
}

.label-right {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 32px;
  color: #e30011;
}

.span-title {
  background-color: #eceef1 !important;
  font-family: Poppins !important;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 22px;
  color: #2d3038;
}

.mainCheckout {
  padding: 0px !important;
  max-width: unset !important;
  background-color: #f5f5f5;
}
.observacao-altura {
  height: 270px !important;
}
.timeline {

  list-style-type: none;
  display: flex;
  text-align: center;
  flex-wrap: wrap;
  overflow-x: scroll;
  overflow-y: hidden;
}

.timeline li {
  transition: all 200ms ease-in;
}

.timeline::-webkit-scrollbar {
  width: 10px !important;
  height: 10px !important;
}

.timeline::-webkit-scrollbar-track {
  background: #ffffff;
}

.timeline::-webkit-scrollbar-thumb {
  background: #fede04;
  border-radius: 10px;
}

.status {
  flex-direction: column;
  padding: 0px 10px;
  display: flex;

  text-align: center;
  justify-content: center;
  border-top: 2px solid #eceef1;
  position: relative;
  transition: all 200ms ease-in;
}

.date {
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  color: #979797;
}

.status-title {
  margin-top: 10px;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  color: #000000;
}

.status span:before {
  content: "";
  width: 17px;
  height: 17px;
  background-color: #fede04;
  border-radius: 17px;
  position: absolute;
  top: -9px;
  left: 42%;
  transition: all 200ms ease-in;
}

.swiper-control {
  text-align: right;
}

.swiper-container {
  width: 100%;
  margin: 0%;
  padding: 0 20px 30px 20px;
}

.swiper-slide {
  width: 150px;
  text-align: center;
  font-size: 16px;
  margin-top: 10px;
}

@media (max-width: 600px) {
  .text {
    font-weight: 400;
    font-size: 1.2rem;
    line-height: 0.2px;

    letter-spacing: 0.15px;

    color: #2d3038;
  }
}

@media (max-width: 960px) {
  .observacao-altura {
    height: auto !important;
  }
}
.link-etiquette{
  color: #bc0000;
  text-decoration: none;
  font-size: 15px;
  margin-bottom: -10px;
}
.link-etiquette:hover{
  text-decoration: underline;
}
</style>

<script>
import ApiService from "../../../services/ApiService";

import Vue from "vue";
import HeaderOrders from "./components/HeaderOrders";
import ExcelModal from "../components/ExcelModal";
import ChangeStatusModal from "../components/ChangeStatusModal";
import EnviadoStatusModal from "../components/EnviadoStatusModal";
import DevolvidoStatusModal from "../components/DevolvidoStatusModal";
import ConfirmModal from "../components/ConfirmModal";
import CancelarStatusModal from "../components/CancelarStatusModal";
import GenerateTagModal from "../components/GenerateTagModal";
import Utils from "../../../Utils/FormatDate";
import moment from "moment";

export default {
  name: "OrderStatus",

  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },

  components: {
    ChangeStatusModal,
    EnviadoStatusModal,
    ConfirmModal,
    CancelarStatusModal,
    GenerateTagModal,
  },

  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },

  data: () => ({
    steps: [],
    deliveryMethods: ["Receber", "Buscar na loja"],
    pedidoAguardando: 1,
    pedidoReprovado: 2,
    pedidoAprovado: 3,
    pedidoEnviado: 4,
    pedidoDevolvido: 5,
    pedidoSeparando: 6,
    pedidoCancelado: 7,
    pedidoEntregue: 8,
    pedidoRetirar: 9,
    pedidoEtiqueta: 10,
    orderStatusList: [],
    itemsCancelled: [],
    bankSlip: 1,
    pix: 2,
    closeNoLoading: false,
    currentOrder: [],
    dialogKey: false,
    componentKey: 1,
    agenciasDialog: false,
    separarDialog: false,
    cancelareDialog: false,
    retirarDialog: false,
    inserirCodigoPostagemDialog: false,
    alterarLinkRastreioDialog: false,
    imprimirEtiquetaDialog: false,
    etiquettesFormatPdf: [],
    etiquettesFormatJpeg: [],
    gerarEtiquetaDialog: false,
    enviarDialog: false,
    devolverDialog: false,
    entregarDialog: false,
    currentResale: [],
    discount: 0.0,
    frete: [],
    endereco: [],
    currentClient: [],
    userTypeInstaller: 3,
    freightQuotation: null,
    etiquette: null,
    apiService: new ApiService(),
    pedido: {
      totalPrice: 0,
      discount: 0,
      fretePrice: 0,
      brandCard: "Mastercard",
      orderStatusList: [],
    },
    descount: 10,
    jadlogId: 2,
    refundTotal: 0,
    order: [],
    isMobile: false,
    src: "",
    page: 1,
    totalPages: 1,
    pageSize: 100000,
    loading: false,
    trackingCode: null,
    companyName: null,
    trackingLink: null,
    descriptionOfCancellation: null,
    headers: [
      {
        text: "SKU",
        class: "item",
        value: "productSku",
        align: "center",
        sortable: false,
      },
      {
        text: "Produto",
        class: "item",
        value: "product.productName",
        align: "center",
        sortable: false,
      },
      {
        text: "Preço na plataforma",
        class: "item",
        value: "priceOriginal",
        align: "center",
        sortable: false,
      },
      {
        text: "Preço no pedido",
        class: "item",
        value: "price",
        align: "center",
        sortable: false,
      },
      {
        text: "Quantidade",
        class: "item",
        value: "qty",
        align: "center",
        sortable: false,
      },
      {
        text: "Subtotal",
        class: "item",
        value: "subTotal",
        align: "center",
        sortable: false,
      },
      {
        text: "Total líquido",
        class: "item",
        value: "actions",
        align: "center",
        sortable: false,
      },
    ],
    headersCancelled: [
      {
        text: "SKU",
        class: "item",
        value: "productSku",
        align: "center",
        sortable: false,
      },
      {
        text: "Produto",
        class: "item",
        value: "product.productName",
        align: "center",
        sortable: false,
      },
      {
        text: "Preço na plataforma",
        class: "item",
        value: "priceOriginal",
        align: "center",
        sortable: false,
      },
      {
        text: "Preço no pedido",
        class: "item",
        value: "price",
        align: "center",
        sortable: false,
      },
      {
        text: "Quantidade",
        class: "item",
        value: "qty",
        align: "center",
        sortable: false,
      },
      {
        text: "Subtotal",
        class: "item",
        value: "subTotal",
        align: "center",
        sortable: false,
      },
      {
        text: "Total líquido",
        class: "item",
        value: "actions",
        align: "center",
        sortable: false,
      },
      {
        text: "Data do cancelamento",
        class: "item",
        value: "refundDate",
        align: "center",
        sortable: false,
      },
    ],
    headerProps: { sortByText: "Ordenar por" },
    agencias: [],
    urlMelhorEnvio: process.env.VUE_APP_URL_MELHOR_ENVIO,
  }),

  watch: {
    calculateDiscount(item) {
      this.discount = item.finalPrice / 10;
      this.componentKey += 1;
    },
  },

  computed: {},

  async created() {
    await this.getOrderById();
  },

  methods: {
    formatDate(date) {
      return Utils.moment(date);
    },
    cancelOrder(){
      this.cancelareDialog = true;
      setTimeout(() => {
        this.$refs.cancelarStatusModal.resetRefundAmount();
      }, 100)
    },
    fillOrderStatusList(listOrder) {
      this.steps = []
      listOrder.forEach((x) => {
        switch (x.status) {
          case 0:
            this.steps.push({
              dateLabel: Utils.moment(x.updated_at),
              title: `Pedido Novo`,
              status: x.status,
            });
            break;
          case 1:
            this.steps.push({
              dateLabel: Utils.moment(x.updated_at),
              title: `Pedido Aguardando`,
              status: x.status,
            });
            break;
          case 2:
            this.steps.push({
              dateLabel: Utils.moment(x.updated_at),
              title: `Pedido Reprovado`,
              status: x.status,
            });
            break;
          case 3:
            this.steps.push({
              dateLabel: Utils.moment(x.updated_at),
              title: `Pedido Aprovado`,
              status: x.status,
            });
            break;
          case 4:
            this.steps.push({
              dateLabel: Utils.moment(x.updated_at),
              title: `Pedido Enviado`,
              status: x.status,
            });
            break;
          case 5:
            this.steps.push({
              dateLabel: Utils.moment(x.updated_at),
              title: `Pedido Devolvido`,
              status: x.status,
            });
            break;
          case 6:
            this.steps.push({
              dateLabel: Utils.moment(x.updated_at),
              title: `Pedido em separação`,
              status: x.status,
            });
            break;
          case 7:
            this.steps.push({
              dateLabel: Utils.moment(x.updated_at),
              title: `Pedido Cancelado`,
              status: x.status,
            });
            break;
          case 8:
            this.steps.push({
              dateLabel: Utils.moment(x.updated_at),
              title: `Pedido Entregue`,
              status: x.status,
            });
            break;
          case 9:
            this.steps.push({
              dateLabel: Utils.moment(x.updated_at),
              title: `Pedido Retirar`,
              status: x.status,
            });
            break;
          case 11:
            this.steps.push({
              dateLabel: Utils.moment(x.updated_at),
              title: `Cancelado parcialmente`,
              status: x.status,
            });
            break;
          default:
            this.steps.push({
              dateLabel: Utils.moment(x.updated_at),
              title: `Etiqueta gerada`,
              status: x.status,
            });
        }
      });
    },
    excel() {
      this.apiService.get(`order/excel/${this.pedido.id}`).then((response) => {
        const excel =
          "data:application/octet-stream;base64," + response.content;
        const link = document.createElement("a");
        link.href = excel;
        link.setAttribute("download", `pedido.xlsx`);
        document.body.appendChild(link);
        link.click();
      });
    },

    async copyQrcode(id) {
      const content = document.getElementById(id).innerHTML;
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard
          .writeText(content)
          .then(() => {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "success",
              title: "",
              message: "Qr Code copiado.",
              trace: null,
            });
          })
          .catch((err) => {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "",
              message: "Não foi possível copiar o Qr Code",
              trace: null,
            });
          });
      }
    },

    showQrCodePix() {
      return (
        moment(new Date(this.pedido.currentDate)).isBefore(
          new Date(this.pedido.expiresInQrCodeUrlPix)
        ) &&
        !this.pedido.orderStatusList.find(
          (step) => step.status === this.pedidoAprovado
        )
      );
    },
    statusPagamento() {
      if (
        this.orderStatusList.find((step) => step.status === this.pedidoAprovado)
      ) {
        return "Pago";
      } else if (
        this.orderStatusList.find(
          (step) => step.status === this.pedidoAguardando
        )
      ) {
        if (
          this.pedido.orderStatus === this.pedidoCancelado &&
          this.pedido.paymentMethod === this.bankSlip
        ) {
          return "Boleto expirado.";
        } else if (
          moment(new Date(this.pedido.currentDate)).isAfter(
            new Date(this.pedido.expiresInQrCodeUrlPix)
          ) &&
          this.pedido.paymentMethod === this.pix
        ) {
          return "Qr Code expirado";
        }
        return "Pendente";
      } else if (
        this.orderStatusList.find(
          (step) => step.status === this.pedidoReprovado
        )
      ) {
        return "Pagamento recusado";
      }
    },

    disabled(status) {
      return !!this.pedido.orderStatusList.find((x) => x.status === status);
    },

    async gerarEtiqueta() {
      if (this.pedido.etiquetaId) {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "info",
          title: `Atenção`,
          message: "A etiqueta já foi gerada!",
          trace: null,
        });
        return;
      } else if (
        this.pedido.freightQuotation == null ||
        this.pedido.deliveryMethod === 1
      ) {
        let message =
          this.pedido.deliveryMethod === 1
            ? "O pedido vai ser retirado na revenda, não é necessario gerar a etiqueta"
            : "O pedido vai ser enviado pela revenda, não é necessario gerar a etiqueta";
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "info",
          title: `Atenção`,
          message: message,
          trace: null,
        });
        return;
      }
      if (this.carrierIsJadlog()) {
        await this.listarAgencias();
        return;
      }
      this.gerarEtiquetaDialog = true;
    },

    carrierIsJadlog() {
      const freightQuotation = JSON.parse(this.pedido.freightQuotation);
      return freightQuotation.company.id === this.jadlogId;
    },

    async listarAgencias() {
      this.loading = true;
      await this.apiService
        .get(`order/agencias?orderId=${this.pedido.id}`)
        .then((resp) => {
          this.agencias = resp.content;
          if (this.agencias && this.agencias.length === 1) {
            const [agencia] = this.agencias;
            this.pedido.agenciaId = agencia.id;
            this.gerarEtiquetaDialog = true;
            return;
          }
          this.agenciasDialog = true;
        })
        .catch((erro) => {
          this.loading = false;
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Erro",
            message: erro.body
              ? erro.body.message
              : "Não foi possível alterar status do pedido",
            trace: null,
          });
        });
    },

    selecionarAgencia(agenciaId) {
      this.pedido.agenciaId = agenciaId;
      this.gerarEtiquetaDialog = true;
    },

    changeStatus(item) {
      item = this.pedido;
      item.TrackingCode = this.trackingCode;
      item.CompanyName = this.companyName;
      item.TrackingLink = this.trackingLink;
      this.editStatus(item);
    },

    async editStatus() {
      this.loading = true;
      this.agenciasDialog = false;
      await this.apiService
        .post(`order/changestatus`, this.pedido)
        .then((resp) => {
          this.getOrderById();
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: "Sucesso",
            message: resp.message
              ? resp.message
              : "Mudança de status efetuada!",
            trace: null,
          });
        })
        .catch((erro) => {
          this.loading = false;
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Erro",
            message: erro.body
              ? erro.body.message
              : "Não foi possível alterar status do pedido",
            trace: null,
          });
        });
    },

    async partiallyCancel() {
      this.loading = true;
      this.agenciasDialog = false;
      await this.apiService
        .post(`order/cancel-partially`, this.pedido)
        .then((resp) => {
          this.getOrderById();
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: "Sucesso",
            message: resp.message
              ? resp.message
              : "Mudança de status efetuada!",
            trace: null,
          });
        })
        .catch((erro) => {
          this.loading = false;
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Erro",
            message: erro.body
              ? erro.body.message
              : "Não foi possível alterar status do pedido",
            trace: null,
          });
        });
    },

    async addTrackingCode() {
      this.pedido.trackingCode = this.trackingCode;
      this.inserirCodigoPostagemDialog = false;
      await this.apiService
        .put(`order/tracking-code`, this.pedido)
        .then(async (resp) => {
          await this.getOrderById();
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: "Sucesso",
            message: resp.message
              ? resp.message
              : "Mudança de status efetuada!",
            trace: null,
          });
        })
        .catch((erro) => {
          this.loading = false;
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Erro",
            message: erro.body
              ? erro.body.message
              : "Não foi possível adicionar o código de rastreio",
            trace: null,
          });
        });
    },

    async showModalTrackingLink() {
      this.alterarLinkRastreioDialog = true;
      this.trackingLink = this.pedido.trackingLink
    },
    async updateTrackingLink() {
      this.alterarLinkRastreioDialog = false;
       const body = {
         trackingLink: this.trackingLink
       }
      await this.apiService
        .put(`order/trackingLink/${this.pedido.id}`, body)
        .then(async (resp) => {
          await this.getOrderById();
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: "Sucesso",
            message: resp.message
              ? resp.message
              : "Link de rastreio atualizado com sucesso!",
            trace: null,
          });
        })
        .catch((erro) => {
          this.loading = false;
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Erro",
            message: erro.body
              ? erro.body.message
              : "Não foi possível atualizar o link de rastreio",
            trace: null,
          });
        });
    },

    downloadEtiquettePdf(etiquette){
      try {
        const excel =  `data:application/octet-stream;base64,${etiquette.pdf}`
        const link = document.createElement("a");
        link.href = excel;
        link.setAttribute("download", `${etiquette.label}.pdf`);
        document.body.appendChild(link);
        link.click();
      } catch (e) {

      }
    },

    async convertPdfToBase64(url) {
      const {statusCode, content} = await this.apiService.post(`order/urlFileToBase64`, {url})
      return statusCode === 200 && content ? content : null
    },
    hasEtiquetteFile(file) {
      return !!(file && (file['jpeg'] || file['pdf']))
    },
    async addEtiquetteFile(file, label) {
      const {jpeg, pdf} = file
      if (jpeg) {
        this.etiquettesFormatJpeg.push({jpeg, label})
      }
      if (pdf) {
        const content = await this.convertPdfToBase64(pdf)
        if (content) {
          this.etiquettesFormatPdf.push({pdf: content, label})
        }
      }
    },
    async collectEtiquetteFiles(files, buildLabel) {
      let count = 1
      while (this.hasEtiquetteFile(files[count])) {
        await this.addEtiquetteFile(files[count], buildLabel(count))
        count++
      }
    },
    async getEtiquettesByShippingLabels() {
      let index = 1
      await this.apiService
          .get(`order/etiquette/${this.pedido.id}`)
          .then(async (response) => {
            const {content: etiquettes} = response
            for (const etiquette of etiquettes) {
              if (etiquette) {
                const label = `do pacote ${index.toString().padStart('4', '0')}/${etiquettes.length.toString().padStart('4', '0')}`
                await this.collectEtiquetteFiles(etiquette.files, () => label)
                index++
              }
            }
          })
          .catch(() => {
            this.imprimirEtiquetaDialog = true
          })
    },
    async getEtiquettesLegacy() {
      await this.apiService
          .get(`order/etiquette/${this.pedido.id}`)
          .then(async (response) => {
            const {content} = response
            console.log(content)
            if (content) {
              const totalFiles = Object.keys(content.files).length
              await this.collectEtiquetteFiles(content.files, (count) =>
                  `do pacote ${count.toString().padStart('4', '0')}/${totalFiles.toString().padStart('4', '0')}`)
            }
            this.imprimirEtiquetaDialog = true
          })
          .catch(() => {
            this.imprimirEtiquetaDialog = true
          })
    },
    async getEtiquette() {
      try {
        this.etiquettesFormatJpeg = []
        this.etiquettesFormatPdf = []

        if (this.pedido.shippingLabels && this.pedido.shippingLabels.length > 0) {
          await this.getEtiquettesByShippingLabels()
          this.imprimirEtiquetaDialog = true
          return
        }
        await this.getEtiquettesLegacy()
      } catch (e) {
        this.imprimirEtiquetaDialog = true
      }
    },

    async editResaleemarks() {
      this.loading = true;
      await this.apiService
        .put(`order/edit-remarks`, this.pedido)
        .then((resp) => {
          this.getOrderById();
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: "Sucesso",
            message: resp.message
              ? resp.message
              : "Observações do pedido atualizado com sucesso",
            trace: null,
          });
        })
        .catch((erro) => {
          this.loading = false;
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Erro",
            message: erro.body
              ? erro.body.message
              : "Não foi possível atualizar as observações do pedido",
            trace: null,
          });
        });
    },

    toggleChangeDialog(item) {
      this.selectedItem = item;
      if (this.pedido.orderStatus === 6) {
        this.separarDialog = true; //devolvido
      } else if (this.pedido.orderStatus === 4) {
        this.currentOrder = item;
        this.enviarDialog = true; //enviado
      } else if (this.pedido.orderStatus === 10) {
        this.gerarEtiquetaDialog = true; //enviado
      } else if (this.pedido.orderStatus === 8) {
        this.entregarDialog = true; //enviado
      } else if (this.pedido.orderStatus === 7) {
        this.changeDialog = true; //enviado
      } else if (this.pedido.orderStatus === 5) {
        this.develverDialog = true; //enviado
      } else if (this.pedido.orderStatus === 9) {
        this.retirarDialog = true; //enviado
      }
    },

    async recebenDados(item) {
      this.pedido.orderStatus = 4;
      this.enviarDialog = false;
      this.trackingCode = item.trackingCode;
      this.companyName = item.companyName;
      this.trackingLink = item.trackingLink;

      this.pedido.TrackingCode = item.trackingCode;
      this.pedido.CompanyName = item.companyName;
      this.pedido.TrackingLink = item.trackingLink;
      await this.editStatus();
    },

    async dadosCancelamento(dados) {
      this.pedido.orderStatus = 7;
      this.cancelareDialog = false;
      this.descriptionOfCancellation = dados.descriptionOfCancellation;
      this.pedido.descriptionOfCancellation = dados.descriptionOfCancellation;
      this.pedido.refundAmount = 0;
      this.pedido.refundType = 0;
      this.pedido.refundType = dados.refundType;
      this.pedido.reasonForCancellation = dados.reasonForCancellation;
      if(this.pedido.refundType == this.refundTotal){
        await this.editStatus();
        return
      }

      this.pedido.refundAmount = dados.refundAmount;
      this.pedido.items = dados.items;

      await this.partiallyCancel()
    },

    async generateShippingLabel(dados) {
      console.log(dados)
      this.pedido.orderStatus = 10;
      this.gerarEtiquetaDialog = false;
      this.pedido.electronicInvoiceKey = dados.electronicInvoiceKey;
      await this.editStatus();
    },

    showPhoto(image) {
      if (!!image && image.includes("Uploads/")) {
        var env_url = process.env.VUE_APP_BASE_URL;
        return env_url + image;
      } else {
        return image;
      }
    },

    calculateTotal() {
      let total = 0;
      this.order.forEach((e) => {
        total = total + e.price * e.qty;
      });
      total = total - this.discount;

      this.total = total;
      this.componentKey += 1;
    },

    async getOrderById() {
      this.loading = true;
      await this.apiService
        .get(`order/get-one?id=` + this.$route.query.id)
        .then((response) => {
          this.pedido = response[0];
          this.freightQuotation = JSON.parse(this.pedido.freightQuotation)
          this.orderStatusList = this.pedido.orderStatusList;
          this.fillOrderStatusList(this.orderStatusList);
          this.order = this.pedido.items;
          this.itemsCancelled = this.pedido.items.filter(x => x.refundDate);
          this.currentOrder = this.pedido.items;
          this.frete.valor = this.pedido.fretePrice;
          this.getClientbyId(this.pedido.clientId);
          this.getAddressbyId(this.pedido.deliveryId);
          this.getResalebyId(this.pedido.resaleId);
          this.calculateTotal();
        })
        .catch((err) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Erro ao buscar este pedido!",
            message: "",
            trace: null,
          });
        });

      this.loading = false;
    },

    calculateSubtotal() {
      return this.pedido.totalPrice + this.pedido.fretePrice + this.pedido.installmentsInterest
    },
    async getAddressbyId(id) {
      this.loading = true;
      await this.apiService
        .get(`order/get-address?id=` + id)
        .then((response) => {
          this.endereco = response[0];
          this.loading = false;
        })
        .catch((err) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Erro ao buscar endereço!",
            message: "",
            trace: null,
          });
          this.loading = false;
        });
    },

    async getClientbyId(id) {
      this.loading = true;
      await this.apiService
        .get(`user/get-one?id=` + id)
        .then((response) => {
          this.currentClient = response;

          this.loading = false;
        })
        .catch((err) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Erro ao buscar cliente!",
            message: "",
            trace: null,
          });
          this.loading = false;
        });
    },
    // TODO: colocar o resaleId certo calculado pelo vagueta
    async getResalebyId(id) {
      this.loading = true;
      await this.apiService
        .get(`user/get-one?id=` + id)
        .then((response) => {
          this.currentResale = response;

          this.loading = false;
        })
        .catch((err) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Erro ao buscar cliente!",
            message: "",
            trace: null,
          });
          this.loading = false;
        });
    },

    async goToRoute(route) {
      if (this.$route.path != route) {
        await this.$router.push(route);
      }
    },

    onResize() {
      this.isMobile = window.innerWidth < 960;
    },
  },
};
</script>
